import { gaEvent } from 'src/utils'

import { formatProducts, getTotalPrice } from './utils'
import { CartProductItem, MldEcommerceProduct, ProductItem } from '../../types'
import { DEFAULT_CURRENCY } from '../../utils'

export type MldEcommerceParameters = {
  currency?: string
  /**
   * Valor total da venda, caso não seja utilizado, é calculado automaticamente a partir dos produtos adicionados
   */
  value?: number
  item_list_id?: string
  item_list_name?: string
  transaction_id?: string
  tax?: string
  shipping?: string
  coupon?: string
  cd_pagina?: number
}

/**
 * Nome dos possíveis eventos mapeados de ecommerce
 */
export type MldEcommerceEventNames =
  | 'remove_from_cart'
  | 'view_cart'
  | 'begin_checkout'
  | 'purchase'
  | 'view_item_list'
  | 'view_item'
  | 'add_to_cart'

/**
 * Parâmetro para {@link ecommerceEvent}
 */
export type MldEcommerceEventParams = {
  eventName: MldEcommerceEventNames
  products: Array<Partial<CartProductItem | ProductItem | MldEcommerceProduct>>
  parameters?: MldEcommerceParameters
}

/**
 * [TARGET]: Eventos de ecommerce
 *
 * [CONTEXTO]: Deve utilizar para disparo em eventos de ecommerce (adicionar no carrinho, visualizar produtos e etc)\
 *
 * [REGRAS]:\
 * - O evento de ecommerce deve ser disparado com o nome do evento e os produtos\
 * - Os produtos devem ser enviados no formato de array de objetos com as propriedades necessárias\
 * - O evento de ecommerce deve conter o valor total da venda, caso não seja informado, o valor é calculado automaticamente a partir dos produtos adicionados
 * - O evento de ecommerce deve conter a moeda utilizada na venda, caso não seja informado, a moeda padrão é BRL
 *
 * [COMO]: Enviar um evento de ecommerce com o nome do evento e os produtos\
 * Enviar os produtos \
 *
 * @param eventProps - Objeto com dados do evento de ecommerce, totalmente customizavel dependendo do evento.
 */
export const ecommerceEvent = (eventProps: MldEcommerceEventParams) =>
  gaEvent({
    event: eventProps.eventName,
    ecommerce: {
      currency: DEFAULT_CURRENCY,
      value: getTotalPrice(eventProps),
      ...eventProps.parameters,
      items: formatProducts(eventProps),
    },
  })
